// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file nodebase/v1/account.proto (package nodebase.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { RequestMeta } from "./common_pb";
import { file_nodebase_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file nodebase/v1/account.proto.
 */
export const file_nodebase_v1_account: GenFile = /*@__PURE__*/
  fileDesc("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", [file_nodebase_v1_common]);

/**
 * Session is a short-lived access token plus a refresh token.
 *
 * @generated from message nodebase.v1.Session
 */
export type Session = Message<"nodebase.v1.Session"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;

  /**
   * @generated from field: int64 access_expires_unix = 3;
   */
  accessExpiresUnix: bigint;
};

/**
 * Describes the message nodebase.v1.Session.
 * Use `create(SessionSchema)` to create a new message.
 */
export const SessionSchema: GenMessage<Session> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 0);

/**
 * @generated from message nodebase.v1.BeginLoginRequest
 */
export type BeginLoginRequest = Message<"nodebase.v1.BeginLoginRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string email = 2;
   */
  email: string;
};

/**
 * Describes the message nodebase.v1.BeginLoginRequest.
 * Use `create(BeginLoginRequestSchema)` to create a new message.
 */
export const BeginLoginRequestSchema: GenMessage<BeginLoginRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 1);

/**
 * @generated from message nodebase.v1.BeginLoginResponse
 */
export type BeginLoginResponse = Message<"nodebase.v1.BeginLoginResponse"> & {
  /**
   * @generated from field: nodebase.v1.LoginMethod method = 1;
   */
  method: LoginMethod;
};

/**
 * Describes the message nodebase.v1.BeginLoginResponse.
 * Use `create(BeginLoginResponseSchema)` to create a new message.
 */
export const BeginLoginResponseSchema: GenMessage<BeginLoginResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 2);

/**
 * @generated from message nodebase.v1.RequestLoginCodeRequest
 */
export type RequestLoginCodeRequest = Message<"nodebase.v1.RequestLoginCodeRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string email = 2;
   */
  email: string;
};

/**
 * Describes the message nodebase.v1.RequestLoginCodeRequest.
 * Use `create(RequestLoginCodeRequestSchema)` to create a new message.
 */
export const RequestLoginCodeRequestSchema: GenMessage<RequestLoginCodeRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 3);

/**
 * @generated from message nodebase.v1.RequestLoginCodeResponse
 */
export type RequestLoginCodeResponse = Message<"nodebase.v1.RequestLoginCodeResponse"> & {
};

/**
 * Describes the message nodebase.v1.RequestLoginCodeResponse.
 * Use `create(RequestLoginCodeResponseSchema)` to create a new message.
 */
export const RequestLoginCodeResponseSchema: GenMessage<RequestLoginCodeResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 4);

/**
 * @generated from message nodebase.v1.VerifyLoginCodeRequest
 */
export type VerifyLoginCodeRequest = Message<"nodebase.v1.VerifyLoginCodeRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string code = 3;
   */
  code: string;

  /**
   * Legacy account-creation input. New servers in web-only mode ignore it and
   * return registration-required for an unknown account. Kept on the wire so
   * already-released clients remain protobuf-compatible while their UI moves
   * to the Web registration flow.
   *
   * @generated from field: string invite_code = 4 [deprecated = true];
   * @deprecated
   */
  inviteCode: string;
};

/**
 * Describes the message nodebase.v1.VerifyLoginCodeRequest.
 * Use `create(VerifyLoginCodeRequestSchema)` to create a new message.
 */
export const VerifyLoginCodeRequestSchema: GenMessage<VerifyLoginCodeRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 5);

/**
 * @generated from message nodebase.v1.GetRegistrationOptionsRequest
 */
export type GetRegistrationOptionsRequest = Message<"nodebase.v1.GetRegistrationOptionsRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;
};

/**
 * Describes the message nodebase.v1.GetRegistrationOptionsRequest.
 * Use `create(GetRegistrationOptionsRequestSchema)` to create a new message.
 */
export const GetRegistrationOptionsRequestSchema: GenMessage<GetRegistrationOptionsRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 6);

/**
 * @generated from message nodebase.v1.RegistrationRegion
 */
export type RegistrationRegion = Message<"nodebase.v1.RegistrationRegion"> & {
  /**
   * Stable lowercase placement identifier (currently "us" or "jp").
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Product display label. Clients may localize it but must submit id.
   *
   * @generated from field: string display_name = 2;
   */
  displayName: string;
};

/**
 * Describes the message nodebase.v1.RegistrationRegion.
 * Use `create(RegistrationRegionSchema)` to create a new message.
 */
export const RegistrationRegionSchema: GenMessage<RegistrationRegion> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 7);

/**
 * @generated from message nodebase.v1.GetRegistrationOptionsResponse
 */
export type GetRegistrationOptionsResponse = Message<"nodebase.v1.GetRegistrationOptionsResponse"> & {
  /**
   * Only regions with enabled, real Worker capacity are returned.
   *
   * @generated from field: repeated nodebase.v1.RegistrationRegion worker_regions = 1;
   */
  workerRegions: RegistrationRegion[];

  /**
   * @generated from field: string default_worker_region = 2;
   */
  defaultWorkerRegion: string;

  /**
   * @generated from field: string registration_url = 3;
   */
  registrationUrl: string;

  /**
   * False once registration is open to everyone: an account created without
   * an invite has no free Worker and subscribes before its first one.
   *
   * @generated from field: bool invite_required = 4;
   */
  inviteRequired: boolean;
};

/**
 * Describes the message nodebase.v1.GetRegistrationOptionsResponse.
 * Use `create(GetRegistrationOptionsResponseSchema)` to create a new message.
 */
export const GetRegistrationOptionsResponseSchema: GenMessage<GetRegistrationOptionsResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 8);

/**
 * @generated from message nodebase.v1.RegisterWithLoginCodeRequest
 */
export type RegisterWithLoginCodeRequest = Message<"nodebase.v1.RegisterWithLoginCodeRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string code = 3;
   */
  code: string;

  /**
   * @generated from field: string invite_code = 4;
   */
  inviteCode: string;

  /**
   * Empty selects the server-advertised default. The stored value is immutable
   * once a Worker has been created; moving a Worker is a separate migration.
   *
   * @generated from field: string worker_region = 5;
   */
  workerRegion: string;
};

/**
 * Describes the message nodebase.v1.RegisterWithLoginCodeRequest.
 * Use `create(RegisterWithLoginCodeRequestSchema)` to create a new message.
 */
export const RegisterWithLoginCodeRequestSchema: GenMessage<RegisterWithLoginCodeRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 9);

/**
 * @generated from message nodebase.v1.RegisterWithLoginCodeResponse
 */
export type RegisterWithLoginCodeResponse = Message<"nodebase.v1.RegisterWithLoginCodeResponse"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: nodebase.v1.Session session = 2;
   */
  session?: Session | undefined;

  /**
   * @generated from field: string workspace_id = 3;
   */
  workspaceId: string;

  /**
   * @generated from field: string worker_region = 4;
   */
  workerRegion: string;
};

/**
 * Describes the message nodebase.v1.RegisterWithLoginCodeResponse.
 * Use `create(RegisterWithLoginCodeResponseSchema)` to create a new message.
 */
export const RegisterWithLoginCodeResponseSchema: GenMessage<RegisterWithLoginCodeResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 10);

/**
 * @generated from message nodebase.v1.VerifyLoginCodeResponse
 */
export type VerifyLoginCodeResponse = Message<"nodebase.v1.VerifyLoginCodeResponse"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: nodebase.v1.Session session = 2;
   */
  session?: Session | undefined;

  /**
   * True when this call created the account, so the client can onboard rather
   * than say "welcome back" to someone who has never been here.
   *
   * @generated from field: bool account_created = 3;
   */
  accountCreated: boolean;
};

/**
 * Describes the message nodebase.v1.VerifyLoginCodeResponse.
 * Use `create(VerifyLoginCodeResponseSchema)` to create a new message.
 */
export const VerifyLoginCodeResponseSchema: GenMessage<VerifyLoginCodeResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 11);

/**
 * @generated from message nodebase.v1.LoginWithPasswordRequest
 */
export type LoginWithPasswordRequest = Message<"nodebase.v1.LoginWithPasswordRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string password = 3;
   */
  password: string;
};

/**
 * Describes the message nodebase.v1.LoginWithPasswordRequest.
 * Use `create(LoginWithPasswordRequestSchema)` to create a new message.
 */
export const LoginWithPasswordRequestSchema: GenMessage<LoginWithPasswordRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 12);

/**
 * @generated from message nodebase.v1.LoginWithPasswordResponse
 */
export type LoginWithPasswordResponse = Message<"nodebase.v1.LoginWithPasswordResponse"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: nodebase.v1.Session session = 2;
   */
  session?: Session | undefined;
};

/**
 * Describes the message nodebase.v1.LoginWithPasswordResponse.
 * Use `create(LoginWithPasswordResponseSchema)` to create a new message.
 */
export const LoginWithPasswordResponseSchema: GenMessage<LoginWithPasswordResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 13);

/**
 * @generated from message nodebase.v1.RefreshSessionRequest
 */
export type RefreshSessionRequest = Message<"nodebase.v1.RefreshSessionRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;
};

/**
 * Describes the message nodebase.v1.RefreshSessionRequest.
 * Use `create(RefreshSessionRequestSchema)` to create a new message.
 */
export const RefreshSessionRequestSchema: GenMessage<RefreshSessionRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 14);

/**
 * @generated from message nodebase.v1.RefreshSessionResponse
 */
export type RefreshSessionResponse = Message<"nodebase.v1.RefreshSessionResponse"> & {
  /**
   * @generated from field: nodebase.v1.Session session = 1;
   */
  session?: Session | undefined;
};

/**
 * Describes the message nodebase.v1.RefreshSessionResponse.
 * Use `create(RefreshSessionResponseSchema)` to create a new message.
 */
export const RefreshSessionResponseSchema: GenMessage<RefreshSessionResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 15);

/**
 * @generated from message nodebase.v1.LogoutRequest
 */
export type LogoutRequest = Message<"nodebase.v1.LogoutRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;
};

/**
 * Describes the message nodebase.v1.LogoutRequest.
 * Use `create(LogoutRequestSchema)` to create a new message.
 */
export const LogoutRequestSchema: GenMessage<LogoutRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 16);

/**
 * @generated from message nodebase.v1.LogoutResponse
 */
export type LogoutResponse = Message<"nodebase.v1.LogoutResponse"> & {
};

/**
 * Describes the message nodebase.v1.LogoutResponse.
 * Use `create(LogoutResponseSchema)` to create a new message.
 */
export const LogoutResponseSchema: GenMessage<LogoutResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 17);

/**
 * @generated from message nodebase.v1.RequestAccountDeletionCodeRequest
 */
export type RequestAccountDeletionCodeRequest = Message<"nodebase.v1.RequestAccountDeletionCodeRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;
};

/**
 * Describes the message nodebase.v1.RequestAccountDeletionCodeRequest.
 * Use `create(RequestAccountDeletionCodeRequestSchema)` to create a new message.
 */
export const RequestAccountDeletionCodeRequestSchema: GenMessage<RequestAccountDeletionCodeRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 18);

/**
 * @generated from message nodebase.v1.RequestAccountDeletionCodeResponse
 */
export type RequestAccountDeletionCodeResponse = Message<"nodebase.v1.RequestAccountDeletionCodeResponse"> & {
};

/**
 * Describes the message nodebase.v1.RequestAccountDeletionCodeResponse.
 * Use `create(RequestAccountDeletionCodeResponseSchema)` to create a new message.
 */
export const RequestAccountDeletionCodeResponseSchema: GenMessage<RequestAccountDeletionCodeResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 19);

/**
 * @generated from message nodebase.v1.DeleteAccountRequest
 */
export type DeleteAccountRequest = Message<"nodebase.v1.DeleteAccountRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * Exact destructive-action acknowledgement. The product UI must collect
   * this deliberately; an authenticated session alone is not confirmation.
   *
   * @generated from field: string confirmation = 2;
   */
  confirmation: string;

  /**
   * Optional six-digit code issued by RequestAccountDeletionCode for this
   * account. Empty skips the check; a non-empty wrong code is refused.
   *
   * @generated from field: string verification_code = 3;
   */
  verificationCode: string;
};

/**
 * Describes the message nodebase.v1.DeleteAccountRequest.
 * Use `create(DeleteAccountRequestSchema)` to create a new message.
 */
export const DeleteAccountRequestSchema: GenMessage<DeleteAccountRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 20);

/**
 * @generated from message nodebase.v1.DeleteAccountResponse
 */
export type DeleteAccountResponse = Message<"nodebase.v1.DeleteAccountResponse"> & {
  /**
   * @generated from field: uint32 deleted_workspaces = 1;
   */
  deletedWorkspaces: number;

  /**
   * @generated from field: uint32 deleted_workers = 2;
   */
  deletedWorkers: number;
};

/**
 * Describes the message nodebase.v1.DeleteAccountResponse.
 * Use `create(DeleteAccountResponseSchema)` to create a new message.
 */
export const DeleteAccountResponseSchema: GenMessage<DeleteAccountResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 21);

/**
 * @generated from message nodebase.v1.StartDeviceLoginRequest
 */
export type StartDeviceLoginRequest = Message<"nodebase.v1.StartDeviceLoginRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * Self-reported and therefore untrusted; shown on the approval page as the
   * device's own claim. Typically the host name.
   *
   * @generated from field: string device_name = 2;
   */
  deviceName: string;

  /**
   * "macos", "windows", "linux", "openwrt", … (lowercase GOOS-like token).
   *
   * @generated from field: string platform = 3;
   */
  platform: string;

  /**
   * Which product is asking: "desktop" or "cli".
   *
   * @generated from field: string client = 4;
   */
  client: string;

  /**
   * @generated from field: string client_version = 5;
   */
  clientVersion: string;
};

/**
 * Describes the message nodebase.v1.StartDeviceLoginRequest.
 * Use `create(StartDeviceLoginRequestSchema)` to create a new message.
 */
export const StartDeviceLoginRequestSchema: GenMessage<StartDeviceLoginRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 22);

/**
 * @generated from message nodebase.v1.StartDeviceLoginResponse
 */
export type StartDeviceLoginResponse = Message<"nodebase.v1.StartDeviceLoginResponse"> & {
  /**
   * The device's secret for PollDeviceLogin. Never shown to the person.
   *
   * @generated from field: string device_code = 1;
   */
  deviceCode: string;

  /**
   * Short, human-checkable code in its display form, e.g. "BCDF-GHJK".
   *
   * @generated from field: string user_code = 2;
   */
  userCode: string;

  /**
   * The page a person opens on any browser and types user_code into.
   *
   * @generated from field: string verification_uri = 3;
   */
  verificationUri: string;

  /**
   * verification_uri with the user code already filled in, for a device that
   * can open a browser itself.
   *
   * @generated from field: string verification_uri_complete = 4;
   */
  verificationUriComplete: string;

  /**
   * @generated from field: int64 expires_unix = 5;
   */
  expiresUnix: bigint;

  /**
   * Minimum seconds between polls.
   *
   * @generated from field: int32 interval_seconds = 6;
   */
  intervalSeconds: number;
};

/**
 * Describes the message nodebase.v1.StartDeviceLoginResponse.
 * Use `create(StartDeviceLoginResponseSchema)` to create a new message.
 */
export const StartDeviceLoginResponseSchema: GenMessage<StartDeviceLoginResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 23);

/**
 * @generated from message nodebase.v1.PollDeviceLoginRequest
 */
export type PollDeviceLoginRequest = Message<"nodebase.v1.PollDeviceLoginRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string device_code = 2;
   */
  deviceCode: string;
};

/**
 * Describes the message nodebase.v1.PollDeviceLoginRequest.
 * Use `create(PollDeviceLoginRequestSchema)` to create a new message.
 */
export const PollDeviceLoginRequestSchema: GenMessage<PollDeviceLoginRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 24);

/**
 * @generated from message nodebase.v1.PollDeviceLoginResponse
 */
export type PollDeviceLoginResponse = Message<"nodebase.v1.PollDeviceLoginResponse"> & {
  /**
   * @generated from field: nodebase.v1.DeviceLoginStatus status = 1;
   */
  status: DeviceLoginStatus;

  /**
   * @generated from field: int32 interval_seconds = 2;
   */
  intervalSeconds: number;

  /**
   * @generated from field: string account_id = 3;
   */
  accountId: string;

  /**
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * @generated from field: nodebase.v1.Session session = 5;
   */
  session?: Session | undefined;
};

/**
 * Describes the message nodebase.v1.PollDeviceLoginResponse.
 * Use `create(PollDeviceLoginResponseSchema)` to create a new message.
 */
export const PollDeviceLoginResponseSchema: GenMessage<PollDeviceLoginResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 25);

/**
 * @generated from message nodebase.v1.GetDeviceLoginRequest
 */
export type GetDeviceLoginRequest = Message<"nodebase.v1.GetDeviceLoginRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * Any case, with or without the separator.
   *
   * @generated from field: string user_code = 2;
   */
  userCode: string;
};

/**
 * Describes the message nodebase.v1.GetDeviceLoginRequest.
 * Use `create(GetDeviceLoginRequestSchema)` to create a new message.
 */
export const GetDeviceLoginRequestSchema: GenMessage<GetDeviceLoginRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 26);

/**
 * @generated from message nodebase.v1.GetDeviceLoginResponse
 */
export type GetDeviceLoginResponse = Message<"nodebase.v1.GetDeviceLoginResponse"> & {
  /**
   * Display form, for the page to show next to "check it matches your device".
   *
   * @generated from field: string user_code = 1;
   */
  userCode: string;

  /**
   * @generated from field: string device_name = 2;
   */
  deviceName: string;

  /**
   * @generated from field: string platform = 3;
   */
  platform: string;

  /**
   * @generated from field: string client = 4;
   */
  client: string;

  /**
   * @generated from field: string client_version = 5;
   */
  clientVersion: string;

  /**
   * Address the request came from, as the control plane saw it.
   *
   * @generated from field: string request_ip = 6;
   */
  requestIp: string;

  /**
   * Whether that address is the one the approving browser is calling from.
   * A hint, not a rule: a CLI on a remote server legitimately differs.
   *
   * @generated from field: bool same_network = 7;
   */
  sameNetwork: boolean;

  /**
   * @generated from field: int64 created_unix = 8;
   */
  createdUnix: bigint;

  /**
   * @generated from field: int64 expires_unix = 9;
   */
  expiresUnix: bigint;
};

/**
 * Describes the message nodebase.v1.GetDeviceLoginResponse.
 * Use `create(GetDeviceLoginResponseSchema)` to create a new message.
 */
export const GetDeviceLoginResponseSchema: GenMessage<GetDeviceLoginResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 27);

/**
 * @generated from message nodebase.v1.DecideDeviceLoginRequest
 */
export type DecideDeviceLoginRequest = Message<"nodebase.v1.DecideDeviceLoginRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string user_code = 2;
   */
  userCode: string;

  /**
   * True signs the device in to the caller's account; false declines it.
   *
   * @generated from field: bool approve = 3;
   */
  approve: boolean;
};

/**
 * Describes the message nodebase.v1.DecideDeviceLoginRequest.
 * Use `create(DecideDeviceLoginRequestSchema)` to create a new message.
 */
export const DecideDeviceLoginRequestSchema: GenMessage<DecideDeviceLoginRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 28);

/**
 * @generated from message nodebase.v1.DecideDeviceLoginResponse
 */
export type DecideDeviceLoginResponse = Message<"nodebase.v1.DecideDeviceLoginResponse"> & {
};

/**
 * Describes the message nodebase.v1.DecideDeviceLoginResponse.
 * Use `create(DecideDeviceLoginResponseSchema)` to create a new message.
 */
export const DecideDeviceLoginResponseSchema: GenMessage<DecideDeviceLoginResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_account, 29);

/**
 * How the second step of a sign-in is completed for a given address.
 *
 * @generated from enum nodebase.v1.LoginMethod
 */
export enum LoginMethod {
  /**
   * @generated from enum value: LOGIN_METHOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * A six-digit code has been emailed; finish with VerifyLoginCode.
   *
   * @generated from enum value: LOGIN_METHOD_CODE = 1;
   */
  CODE = 1,

  /**
   * The account has an operator-set password; finish with LoginWithPassword.
   * Nothing was emailed.
   *
   * @generated from enum value: LOGIN_METHOD_PASSWORD = 2;
   */
  PASSWORD = 2,
}

/**
 * Describes the enum nodebase.v1.LoginMethod.
 */
export const LoginMethodSchema: GenEnum<LoginMethod> = /*@__PURE__*/
  enumDesc(file_nodebase_v1_account, 0);

/**
 * @generated from enum nodebase.v1.DeviceLoginStatus
 */
export enum DeviceLoginStatus {
  /**
   * @generated from enum value: DEVICE_LOGIN_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Not decided yet; poll again after interval_seconds.
   *
   * @generated from enum value: DEVICE_LOGIN_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * Polled faster than allowed; poll again after the (larger)
   * interval_seconds in this response.
   *
   * @generated from enum value: DEVICE_LOGIN_STATUS_SLOW_DOWN = 2;
   */
  SLOW_DOWN = 2,

  /**
   * Approved; session, account_id and email are set. The device code is spent.
   *
   * @generated from enum value: DEVICE_LOGIN_STATUS_APPROVED = 3;
   */
  APPROVED = 3,

  /**
   * The person declined on the page. The device code is spent.
   *
   * @generated from enum value: DEVICE_LOGIN_STATUS_DENIED = 4;
   */
  DENIED = 4,

  /**
   * Nobody decided before the deadline; start over.
   *
   * @generated from enum value: DEVICE_LOGIN_STATUS_EXPIRED = 5;
   */
  EXPIRED = 5,
}

/**
 * Describes the enum nodebase.v1.DeviceLoginStatus.
 */
export const DeviceLoginStatusSchema: GenEnum<DeviceLoginStatus> = /*@__PURE__*/
  enumDesc(file_nodebase_v1_account, 1);

/**
 * AccountService handles login and session lifecycle (browser device login,
 * email one-time code, operator password).
 *
 * @generated from service nodebase.v1.AccountService
 */
export const AccountService: GenService<{
  /**
   * BeginLogin is the first step of a product sign-in: given an address, it
   * says which second step follows and, when that step is the emailed code,
   * sends the code in the same call. Accounts an operator set a password on
   * (control-api set-password) get LOGIN_METHOD_PASSWORD and no email; every
   * other address — registered or not — gets LOGIN_METHOD_CODE and a code,
   * exactly as RequestLoginCode would, so this is no more of an
   * account-existence oracle than that call is. What it does disclose is which
   * addresses carry an operator password: those are the operator's own
   * accounts, and guessing their passwords is bounded by LoginWithPassword's
   * lockout, not by keeping the method secret. It exists because a person who
   * cannot receive email (an app reviewer, a device lane) should never be shown
   * a code screen and left to discover the password path.
   *
   * @generated from rpc nodebase.v1.AccountService.BeginLogin
   */
  beginLogin: {
    methodKind: "unary";
    input: typeof BeginLoginRequestSchema;
    output: typeof BeginLoginResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.AccountService.RequestLoginCode
   */
  requestLoginCode: {
    methodKind: "unary";
    input: typeof RequestLoginCodeRequestSchema;
    output: typeof RequestLoginCodeResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.AccountService.VerifyLoginCode
   */
  verifyLoginCode: {
    methodKind: "unary";
    input: typeof VerifyLoginCodeRequestSchema;
    output: typeof VerifyLoginCodeResponseSchema;
  },
  /**
   * GetRegistrationOptions is the public, server-owned description of the
   * Worker locations currently open to invited registrations. A region that
   * has no real provisioning capacity must not be returned here.
   *
   * @generated from rpc nodebase.v1.AccountService.GetRegistrationOptions
   */
  getRegistrationOptions: {
    methodKind: "unary";
    input: typeof GetRegistrationOptionsRequestSchema;
    output: typeof GetRegistrationOptionsResponseSchema;
  },
  /**
   * RegisterWithLoginCode is the only account-creation RPC. Product clients
   * use VerifyLoginCode for existing accounts; the Web onboarding flow uses
   * this explicit invite + location transaction for a new account.
   *
   * @generated from rpc nodebase.v1.AccountService.RegisterWithLoginCode
   */
  registerWithLoginCode: {
    methodKind: "unary";
    input: typeof RegisterWithLoginCodeRequestSchema;
    output: typeof RegisterWithLoginCodeResponseSchema;
  },
  /**
   * LoginWithPassword serves the accounts an operator has set a password for
   * (control-api set-password) — chiefly operator accounts whose mailbox
   * cannot receive a code. The emailed code stays the product login; an
   * account without a stored password cannot use this.
   *
   * @generated from rpc nodebase.v1.AccountService.LoginWithPassword
   */
  loginWithPassword: {
    methodKind: "unary";
    input: typeof LoginWithPasswordRequestSchema;
    output: typeof LoginWithPasswordResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.AccountService.RefreshSession
   */
  refreshSession: {
    methodKind: "unary";
    input: typeof RefreshSessionRequestSchema;
    output: typeof RefreshSessionResponseSchema;
  },
  /**
   * Logout revokes the session that owns the presented refresh token.
   * Possession of the refresh token is the authorization — no access token is
   * required, so a client whose access token has already expired can still end
   * its session. Revoking an unknown token succeeds: the caller's goal (that
   * session no longer works) is already true.
   *
   * @generated from rpc nodebase.v1.AccountService.Logout
   */
  logout: {
    methodKind: "unary";
    input: typeof LogoutRequestSchema;
    output: typeof LogoutResponseSchema;
  },
  /**
   * RequestAccountDeletionCode emails a short-lived code to the authenticated
   * account. DeleteAccount will not accept a login code or a code issued for
   * another account.
   *
   * @generated from rpc nodebase.v1.AccountService.RequestAccountDeletionCode
   */
  requestAccountDeletionCode: {
    methodKind: "unary";
    input: typeof RequestAccountDeletionCodeRequestSchema;
    output: typeof RequestAccountDeletionCodeResponseSchema;
  },
  /**
   * DeleteAccount permanently removes the authenticated account and its
   * Workspace data. It requires the deliberate acknowledgement; the emailed
   * deletion code is optional (App Store guideline 5.1.1(v): deletion must be
   * completable in the app without extra steps) and is checked when sent. The
   * access session is revoked only after every external cleanup succeeds, so a
   * partial failure remains retryable.
   *
   * @generated from rpc nodebase.v1.AccountService.DeleteAccount
   */
  deleteAccount: {
    methodKind: "unary";
    input: typeof DeleteAccountRequestSchema;
    output: typeof DeleteAccountResponseSchema;
  },
  /**
   * Browser sign-in, in the shape of the OAuth 2.0 device authorization grant
   * (RFC 8628). A Desktop app, CLI or router cannot host a Web login itself,
   * so it asks for a pair of codes, sends the person to the Web page that
   * signs in or registers them, and waits. The device code is the device's
   * secret; the user code is what the person checks on the page.
   *
   * StartDeviceLogin is unauthenticated (it is how a device obtains an
   * identity) and rate-limited per source. The device-reported name and
   * platform are shown on the approval page, so a person can tell a request
   * they started from one somebody else is trying to get them to approve.
   *
   * @generated from rpc nodebase.v1.AccountService.StartDeviceLogin
   */
  startDeviceLogin: {
    methodKind: "unary";
    input: typeof StartDeviceLoginRequestSchema;
    output: typeof StartDeviceLoginResponseSchema;
  },
  /**
   * PollDeviceLogin is the device's wait. Unauthenticated: possession of the
   * device code is the authorization. An approval is redeemed exactly once —
   * the poll that returns the session also spends the device code. A device
   * that polls faster than the interval is told DEVICE_LOGIN_STATUS_SLOW_DOWN
   * and given a longer interval.
   *
   * @generated from rpc nodebase.v1.AccountService.PollDeviceLogin
   */
  pollDeviceLogin: {
    methodKind: "unary";
    input: typeof PollDeviceLoginRequestSchema;
    output: typeof PollDeviceLoginResponseSchema;
  },
  /**
   * GetDeviceLogin is the approval page's read: what is asking, from where.
   * It needs the signed-in account session of the person approving.
   *
   * @generated from rpc nodebase.v1.AccountService.GetDeviceLogin
   */
  getDeviceLogin: {
    methodKind: "unary";
    input: typeof GetDeviceLoginRequestSchema;
    output: typeof GetDeviceLoginResponseSchema;
  },
  /**
   * DecideDeviceLogin approves or denies a pending request for the caller's
   * account. Single use: a code that was already decided, or has expired, is
   * refused the same way as one that never existed.
   *
   * @generated from rpc nodebase.v1.AccountService.DecideDeviceLogin
   */
  decideDeviceLogin: {
    methodKind: "unary";
    input: typeof DecideDeviceLoginRequestSchema;
    output: typeof DecideDeviceLoginResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_nodebase_v1_account, 0);

